import { render, staticRenderFns } from "./SubMessage.vue?vue&type=template&id=185e0e75&scoped=true"
import script from "./SubMessage.vue?vue&type=script&lang=js"
export * from "./SubMessage.vue?vue&type=script&lang=js"
import style0 from "./SubMessage.vue?vue&type=style&index=0&id=185e0e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e0e75",
  null
  
)

export default component.exports